<div *transloco="let t">
  <div class="mt-7" *ngIf="licenses$ | withLoader | async as licenses">
    <app-visual-navigation
      [dashboardSK]="licenses.dashboardSK"
      [dashboardSchool]="licenses.dashboardSchool"
      [evalCalculator]="licenses.evalCalculator"
      [childPortfolio]="licenses.childPortfolio"
      [isDemo]="isDemoKindergarten"
      [managementTrial]="licenses.managementTrial"
      [managementAccess]="licenses.managementAccess"
      [testKit]="licenses.testKit"
    ></app-visual-navigation>

    <ng-template #freeVisual>
      <app-visual-navigation
        [evalCalculator]="licenses.evalCalculator"
        [managementTrial]="licenses.managementTrial"
        [managementAccess]="licenses.managementAccess"
      ></app-visual-navigation>
    </ng-template>

    <!-- Try DEMO -->
    <div class="demo-wrapper mb-5" *ngIf="isSwitchDemoKindergartenVisible">
      <div class="demo">
        <span>{{ t('shared/tryDemo') }}</span>
        <button type="button" class="btn btn-outline-dark" (click)="switchDemoKindergartenService.switchToDemoKindergarten()">
          {{ t('shared/demoKindergarten') }}
        </button>
      </div>
    </div>

    <!-- TODO: If still commentend in 2027 - safe to delete -->
    <!-- <ng-container *ngIf="(licenses.displayTestResult || licenses.displayTestResultZ) && (isExperiencedKindergarten$ | withLoader | async)">
      <ng-container *ngIf="childResultsPreviewUnCompleted$ | async | slice : 0 : 4 as childResultsPreviewUnCompleted">
        <ng-container *ngIf="childResultsPreviewCompleted$ | async | slice : 0 : 4 as childResultsPreviewCompleted">
          <section class="mb-5" *ngIf="childResultsPreviewUnCompleted.length > 0">
            <div class="section-title">{{ t('support/lastDiagnostik') }}</div>
            <app-report-preview
              [childResults]="childResultsPreviewUnCompleted$ | async | slice : 0 : 4"
              [childResultsCompleted]="childResultsPreviewCompleted$ | async | slice : 0 : 4"
            ></app-report-preview>
          </section>
        </ng-container>
      </ng-container>
    </ng-container> -->

    <section *ngIf="showPromo$ | async" class="mb-5">
      <div class="section-title">{{ t('support/introToTools') }}</div>
      <app-promo-product
        *ngIf="!licenses.dashboardSchool"
        [hasLicense]="false"
        [products]="recommendedProducts$ | withLoader | async"
      ></app-promo-product>
      <app-promo-product [hasLicense]="true" [products]="ownedProducts$ | withLoader | async"></app-promo-product>
    </section>
  </div>

  <app-archive-notification></app-archive-notification>
</div>
